export default "__VITE_ASSET__DHmrSGr7__"